import { Route, Routes } from '@angular/router';


const homeRoutes: Route = {
    path: '',
    loadChildren: () => import('./home/home.routes').then(m => m.HOME_ROUTES)
};

const adminRoutes: Route = {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
};

export const routes: Routes = [adminRoutes, homeRoutes];